module.exports = __webpack_public_path__ + "static/media/canvas.677207da.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SkwizColors/canvas.gif
// module id = ./src/assets/SkwizColors/canvas.gif
// module chunks = 0